import React, { useState } from 'react';
import './Header.scss';
import tw from '../../_assets/_img/icons/tw.svg';
import fb from '../../_assets/_img/icons/fb.svg';
import ig from '../../_assets/_img/icons/ig-white.svg';
import copy from '../../_assets/_img/icons/copy.svg';
import huluLogo from '../../_assets/_img/hulu-logo.svg';
import {CopyToClipboard} from 'react-copy-to-clipboard';

const Header = () => {
  const [clipboardContent, setClipboardContent] = useState({
    value: '',
    copied: false
  });

  return (
    <header className="cnn-sponsorcontent-header">
      <nav className="cnn-navbar">
        <a href="https://www.cnn.com" data-analytics="header_logo" className="cnn-logo">
          <img src="https://i.cdn.turner.com/cnn/.element/img/4.0/logos/cnn_logo_badge.png" alt="CNN Logo Badge"/>
        </a>
        <a className="back-to-cnn"href="https://www.cnn.com">&lt; Back to CNN </a>
        <div className="social-bar">
          {clipboardContent.copied && (<span>Link Copied!</span>)}
          <span>
            <a href="https://www.facebook.com/hulu/" target="_blank">
              <img src={fb} />
            </a>
          </span>
          <span>
            <a href="https://twitter.com/hulu" target="_blank">
              <img src={tw} />
            </a>
          </span>
          <span>
            <a href="https://www.instagram.com/hulu/" target="_blank">
              <img src={ig} />
            </a>
          </span>

          <CopyToClipboard text={clipboardContent.value}
            onCopy={() => {
              setClipboardContent({ value: 'https://asfd', copied: true});
              setTimeout(function(){
                setClipboardContent({ value: '', copied: false});
              }, 10000);
            }}>
          <span>
            <img src={copy} />
          </span>
        </CopyToClipboard>
        </div>
      </nav>
      <div className="header-banner">Content by Hulu</div>
    </header>
  );
  
}
export default Header;
